<template>
  <b-form
    autocomplete="off"
    @submit.prevent="SearchOpportunityData"
  >
    <b-row class="mb-2">
      <b-col cols="4">
        <b-form-group>
          <b-input-group class="input-group-merge">
            <b-form-input
              id="vi-name"
              v-model="form.params.name"
              type="text"
              autocomplete="off"
              :placeholder="t('Title')"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group>
          <b-input-group class="input-group-merge">
            <b-form-input
              id="vi-vendor_code"
              v-model="form.params.vendor_code"
              type="text"
              autocomplete="off"
              :placeholder="t('Vendor Code')"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group>
          <v-select
            v-model="form.params.status"
            class="p-0 border-0 bg-white"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="para_value"
            :reduce="op => op.para_id"
            :placeholder="t('Status')"
            :options="statusOptions"
          />
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group>
          <v-select
            v-model="form.params.period"
            class="p-0 border-0 bg-white"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="label"
            :reduce="op => op.value"
            :placeholder="t('Period')"
            :options="periodOptions[$i18n.locale]"
            @input="onChangePeriod"
          />
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group>
          <b-input-group class="input-group-merge">
            <flat-pickr
              v-model="form.params.start_date"
              :placeholder="t('Select Start Date')"
              class="form-control"
              :class="isDateDisable ? 'pointer-events-none' : 'remove-readonly'"
              :config="{ dateFormat: 'Y-m-d'}"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group>
          <b-input-group class="input-group-merge">
            <flat-pickr
              v-model="form.params.end_date"
              class="form-control"
              :placeholder="t('Select End Date')"
              :class="isDateDisable ? 'pointer-events-none' : 'remove-readonly'"
              :config="{ dateFormat: 'Y-m-d'}"
            />
            <!-- disable:[{from:'1970-01-01',to:form.start_date}] -->
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        class="text-center"
      >
        <b-button
          variant="success mx-1"
          type="submit"
        >
          {{ t('Search') }}
        </b-button>
        <b-button
          variant="danger mx-1"
          @click="resetFilter"
        >
          {{ t('Reset') }}
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import 'bootstrap-vue'
import vSelect from 'vue-select'
import { useUtils } from '@core/libs/i18n'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import store from '@/store'
import { periodOptions, getDateByPeriod } from '@/utils/common'

export default {
  components: {
    vSelect,
    flatPickr,
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      periodOptions,
      isDateDisable: true,
      statusOptions: [],
      form: {
        sortBy: 'id',
        sortOrder: 'desc',
        size: '10',
        pageNumber: '',
        params: {
          name: '',
          vendor_code: '',
          status: '',
          start_date: '',
          end_date: '',
          period: '',
        },

      },
    }
  },
  mounted() {
    // let today = new Date()
    // const dd = String(today.getDate()).padStart(2, '0')
    // const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    // const yyyy = today.getFullYear()
    // today = `${yyyy}-${mm}-${dd}`
    this.form.params.start_date = moment().startOf('month').format('YYYY-MM-DD')
    this.form.params.end_date = moment().endOf('month').format('YYYY-MM-DD')
    this.form.params.period = '4'
    this.SearchOpportunityData()
    this.getOpportunityStatus()
  },
  methods: {
    getOpportunityStatus() {
      store.dispatch('opportunityStore/opportunityStepStatus').then(response => {
        this.statusOptions = response.data.data
      })
    },
    onChangePeriod(val) {
      const dates = getDateByPeriod(val)
      this.form.params.start_date = dates['0']
      this.form.params.end_date = dates['1']
      this.isDateDisable = dates['2']
    },
    SearchOpportunityData() {
      this.$emit('searchData', this.form)
    },
    resetFilter() {
      this.form = {
        sortBy: 'id',
        sortOrder: 'desc',
        size: '10',
        pageNumber: '',
        params: {
          name: '',
          vendor_code: '',
          status: '',
          start_date: '',
          end_date: '',
          period: '',
        },
      }
      this.SearchOpportunityData()
    },
  },
}
</script>

<style>

</style>
